import React, { FC } from 'react';
import { Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { Layouts } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
}));

const PostController: FC = () => {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Layouts.App1Column desktopSize={8} main={<Typography>Intentionally Blank</Typography>} />
    </div>
  );
};

export default PostController;
